module.exports = __webpack_public_path__ + "app/kiss-seller/billing-warrants-39j9ek5e.html";